/**
 * Decodes GET /email-config obfuscation: server inserts random A–Z / a–z between
 * each real character. Recover plaintext by taking indices 0, 2, 4, … only.
 * Must stay in sync with backend/app/helper/emailConfigGetObfuscation.ts
 */
export const deobfuscateEmailConfigField = (obfuscated: string): string => {
  if (!obfuscated) return "";
  const units = Array.from(obfuscated);
  let out = "";
  for (let i = 0; i < units.length; i += 2) {
    out += units[i];
  }
  return out;
};
